<template>
    <v-card :width="widthProp" elevation="0" style="border-radius: 10px">
        <v-card-text class="pb-10 px-5">
            <v-form
                v-model="student_detail_status"
                ref="form"
                :disabled="disabledRules"
            >
                <v-row>
                    <v-col class="pt-5" style="padding-bottom: 2px;">
                        <div class="prompt-title">
                            <strong>*</strong>{{ $t("message.form.studentData.studentImage") }}
                        </div>
                    </v-col>
                </v-row>
                <v-row class="mt-3">
                    <v-col cols="12" sm="6" :md="responsiveWithFrom" class="d-flex justify-center align-center">
                        <div style="border: 4px dashed #D4D9DE; border-radius: 10px; height:160px; max-width:295px; width:100%; background: #FAFAFD;"
                        >
                            <div class="d-flex justify-center align-center" id="test" style="height:160px; width:100%;margin-top:-5px; position: relative;">
                                <v-img

                                    id="camera"
                                    src="../../assets/camera_alt.svg"
                                    alt="your image"
                                    style="position: absolute;"
                                />
                                <img
                                    v-if="student_detail?.student_img_base64?.data"
                                    id="blah"
                                    :src="
                                        student_detail?.student_img_base64?.data
                                    "
                                    alt="your image"
                                    style="
                                        height: 90%;
                                        width: auto;
                                        max-width: 60%;
                                        display: block;
                                        position: absolute;
                                        top: 50%;
                                        left: 50%;
                                        transform: translate(-50%, -50%);
                                        object-fit: cover;
                                    "
                                />
                                <div
                                    id="text-blah"
                                    style="
                                        color: #ff544a;
                                        position: absolute;
                                        display: none;
                                        min-width: 50px;
                                        max-width: 140px;
                                        text-align: center;
                                    "
                                >
                                    {{ $t("message.form.studentData.imageOverSize") }}
                                </div>
                                <v-file-input
                                v-if="!disabledRules"
                                hide-input
                                accept="image/png, image/jpeg"
                                truncate-length="15"
                                v-on:change="inputFile"
                                id="imgInp"
                                style="padding:0.5rem 0rem; margin:0rem 0rem;"
                                prepend-icon="mdi-pencil"
                                class="align-self-end justify-end"
                                ></v-file-input>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" md="7" sm="6">
                        <div class="mt-2 sarabun-14">
                            <li>{{ $t("message.form.studentData.imageRules.content1") }}</li>
                            <li>{{ $t("message.form.studentData.imageRules.content2") }}</li>
                            <li>{{ $t("message.form.studentData.imageRules.content3") }}</li>
                            <li>{{ $t("message.form.studentData.imageRules.content4") }}</li>
                            <li>{{ $t("message.form.studentData.imageRules.content5") }}</li>
                            <li>{{ $t("message.form.studentData.imageRules.content6") }}</li>
                            <li>{{ $t("message.form.studentData.imageOverSize") }}</li>
                        </div>
                    </v-col>

                    <v-col cols="2" v-if="from == 'candidates'">
                        <v-row no-gutters align="center" justify="end">
                            <v-img
                                :src="require('@/assets/Group92907.png')"
                            ></v-img>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row class="pa-0">
                    <v-col class="py-0 pt-4">
                        <v-divider></v-divider>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="py-0 pt-7" style="margin-bottom: 14px;">
                        <div class="prompt-title">
                            {{ $t("message.form.topics.classroomApplication") }}
                        </div>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" sm="6" md="6" class="py-0 my-1 pr-sm-2 pr-md-2 pr-xs-3">
                        <div class="py-1 form-label">
                            {{ $t("message.form.classData.classroom") }}
                            <strong>*</strong>
                        </div>
                        <!-- <v-select
                            :disabled="stepActive == 5 || from == 'candidates'"
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder="
                                $t('message.form.classData.fillClassroom')
                            "
                            v-model="student_detail.student_year"
                            :items="student_years"
                            item-value="value"
                            :item-text="locale == 'th' ? 'student_year_name_th' : 'student_year_name_en'"
                            :rules="classroomRules"
                            @change="onChangeStudentYear"
                            required
                        ><template #message="{ message }">
                                {{ $t(message) }}
                            </template></v-select> -->
                        <v-select
                            v-model="student_detail.student_year"
                            outlined
                            :items="gradeLevelOptions"
                            :item-text="`label_${locale}`"
                            item-value="value"
                            disabled
                            dense
                        ></v-select>
                    </v-col>

                    <v-col cols="12" sm="6" md="6" class="py-0 my-1 pl-sm-2 pl-xs-3">
                        <div class="py-1 form-label">
                            {{ $t("message.form.classData.curriculum") }}
                            <strong>*</strong>
                        </div>
                        <v-select
                            dense
                            outlined
                            :disabled="
                                student_detail?.student_year == 0 ||
                                disabledRules ||
                                stepActive == 5 ||
                                from == 'candidates'
                            "
                            hide-details="auto"
                            v-bind:placeholder="
                                $t('message.form.classData.fillCurriculum')
                            "
                            v-model="student_detail.program"
                            :items="programs"
                            item-value="value"
                            :item-text="locale == 'th' ? 'program_name_th' : 'program_name_en'"
                            :rules="curriculumRules"
                            v-on:change="onSelectProgram"
                            required
                        ><template #message="{ message }">
                                {{ $t(message) }}
                            </template></v-select>
                    </v-col>

                    <v-col cols="12" sm="6" md="12" class="py-0 my-1 pr-md-3 pr-sm-2 pr-xs-3">
                        <div class="py-1 form-label">{{ $t("message.form.classData.talent") }}</div>
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            :placeholder="$t('message.form.classData.fillTalent')"
                            v-model="student_detail.special_skill"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="pa-0">
                    <v-col class="py-0 pt-7">
                        <v-divider></v-divider>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="py-0">
                        <div class="prompt-title" hide-details="auto" style="margin:14px 0px">
                            {{ $t("message.form.topics.studentInformation") }}
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <!--name-->
                    <v-col cols="12" sm="6" md="6" class="py-0 my-1 pl-3 pr-sm-2 pr-xs-3">
                        <div class="py-1 form-label" hide-details="auto">
                            {{ $t("message.form.studentData.ID") }}
                            <strong>*</strong>
                        </div>
                        <v-text-field
                            class="form-input"
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder="
                                $t('message.form.studentData.fillID')
                            "
                            v-model="student_detail.national_id"
                            :rules="national_id_rule"
                            v-on:keypress="isNationalLetter($event)"
                            v-mask="'N NNNN NNNNN NN N'"
                            required
                        >
                            <template #message="{ message }">
                                {{ $t(message) }}
                            </template></v-text-field
                        >
                    </v-col>

                    <v-col cols="12" sm="6" md="6" class="py-0 my-1 pl-sm-2 pl-xs-3 pr-3">
                        <div class="py-1 form-label">
                            {{ $t("message.form.studentData.gender") }}
                            <strong>*</strong>
                        </div>
                        <v-radio-group
                            row
                            class="py-0 mt-2"
                            hide-details="auto"
                            v-model="student_detail.gender"
                            :rules="[
                                (v) =>
                                    !!v ||
                                    'message.form.studentData.fillGender',
                            ]"
                            required
                            readonly
                            id="gender_radio"
                        >
                            <v-radio
                                v-bind:label="
                                    $t('message.form.studentData.male')
                                "
                                value="MALE"
                                color="orange"
                                class="mr-16"
                            ></v-radio>
                            <!-- <v-radio
                                v-bind:label="
                                    $t('message.form.studentData.female')
                                "
                                value="FEMALE"
                                color="orange"
                            ></v-radio> -->
                            <template #message="{ message }">
                                {{ $t(message) }}
                            </template>
                        </v-radio-group>
                    </v-col>

                    <v-col cols="12" sm="3" md="3" class="py-0 my-1 pl-3 pr-sm-2 pr-xs-3">
                        <div
                            class="py-1 pl-1 form-label"
                            hide-details="auto"
                            style="width: 200px"
                        >
                            {{ $t("message.form.studentData.title") }}
                            <strong>*</strong>
                        </div>
                        <v-select
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder="
                                $t('message.form.studentData.fillTitle')
                            "
                            :items="prefixes.filter((prefix) => ['เด็กชาย', 'ด.ช.'].includes(prefix.text_th))"
                            v-on:change="processPrefix_TH(student_detail)"
                            v-model="student_detail.prefix_th"
                            :rules="[
                                (v) =>
                                    !!v ||
                                    'message.form.studentData.invalidTitle',
                            ]"
                            required
                            item-text="text_th"
                            item-value="id"
                        >
                            <template #message="{ message }">
                                {{ $t(message) }}
                            </template></v-select
                        >
                    </v-col>

                    <v-col cols="12" sm="9" md="9" class="py-0 my-1">
                        <v-row>
                            <v-col cols="12" sm="6" md="6" dense class="pl-sm-2 pr-sm-2 pr-xs-3 pl-xs-3">
                                <div
                                    class="py-1 form-label"
                                    hide-details="auto"
                                >
                                    {{
                                        $t(
                                            "message.form.studentData.firstNameTH"
                                        )
                                    }}
                                    <strong>*</strong>
                                </div>
                                <v-text-field
                                    dense
                                    outlined
                                    hide-details="auto"
                                    v-bind:placeholder="
                                        $t(
                                            'message.form.studentData.fillFirstNameTH'
                                        )
                                    "
                                    v-model="student_detail.name_th"
                                    :rules="[
                                        (v) =>
                                            !!v ||
                                            'message.form.studentData.fillFirstNameTH',
                                    ]"
                                    required
                                    v-on:keypress="isThaiLetter($event)"
                                    @change="onChangeStudentNameTh()"
                                >
                                    <template #message="{ message }">
                                        {{ $t(message) }}
                                    </template></v-text-field
                                >
                            </v-col>

                            <v-col cols="12" sm="6" md="6" dense class="pl-sm-2 pl-xs-3 pr-3">
                                <div
                                    class="py-1 form-label"
                                    hide-details="auto"
                                >
                                    {{
                                        $t(
                                            "message.form.studentData.lastNameTH"
                                        )
                                    }}
                                    <strong>*</strong>
                                </div>
                                <v-text-field
                                    dense
                                    outlined
                                    hide-details="auto"
                                    v-bind:placeholder="
                                        $t(
                                            'message.form.studentData.fillLastNameTH'
                                        )
                                    "
                                    v-model="student_detail.surname_th"
                                    :rules="[
                                        (v) =>
                                            !!v ||
                                            'message.form.studentData.fillLastNameTH',
                                    ]"
                                    required
                                    v-on:keypress="isThaiLetter($event)"
                                    @change="onChangeStudentNameTh()"
                                >
                                    <template #message="{ message }">
                                        {{ $t(message) }}
                                    </template></v-text-field
                                >
                            </v-col>
                        </v-row>
                    </v-col>

                    <v-col cols="12" sm="3" md="3" class="py-0 my-1 pr-sm-2 pr-xs-3 pl-3">
                        <div
                            class="py-1 pl-1 form-label"
                            hide-details="auto"
                            style="width: 200px"
                        >
                            {{ $t("message.form.studentData.title") }}
                            <strong>*</strong>
                        </div>
                        <v-select
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder="
                                $t('message.form.studentData.fillTitle')
                            "
                            :items="prefixEN.filter((prefix) => ['เด็กชาย', 'ด.ช.'].includes(prefix.text_th))"
                            v-on:change="processPrefix_EN(student_detail)"
                            v-model="student_detail.prefix_en"
                            :rules="[
                                (v) =>
                                    !!v ||
                                    'message.form.studentData.invalidTitle',
                            ]"
                            required
                            item-text="text_en"
                            item-value="id"
                        >
                            <template #message="{ message }">
                                {{ $t(message) }}
                            </template></v-select
                        >
                    </v-col>

                    <v-col cols="12" sm="9" md="9" class="py-0 my-1">
                        <v-row>
                            <v-col cols="12" sm="6" md="6" class="pl-sm-2 pr-sm-2 pr-xs-3 pl-xs-3">
                                <div
                                    class="py-1 form-label"
                                    hide-details="auto"
                                >
                                    {{
                                        $t(
                                            "message.form.studentData.firstNameEN"
                                        )
                                    }}
                                    <strong>*</strong>
                                </div>
                                <v-text-field
                                    dense
                                    outlined
                                    hide-details="auto"
                                    v-bind:placeholder="
                                        $t(
                                            'message.form.studentData.fillFirstNameEN'
                                        )
                                    "
                                    v-model="student_detail.name_en"
                                    :rules="[
                                        (v) =>
                                            !!v ||
                                            'message.form.studentData.fillFirstNameEN',
                                    ]"
                                    required
                                    v-on:keypress="isEngLetter($event)"
                                    @change="onChangeStudentNameEn()"
                                >
                                    <template #message="{ message }">
                                        {{ $t(message) }}
                                    </template></v-text-field
                                >
                            </v-col>

                            <v-col cols="12" sm="6" md="6" class="pl-sm-2 pr-3 pl-xs-3">
                                <div
                                    class="py-1 form-label"
                                    hide-details="auto"
                                    style="width: 200px"
                                >
                                    {{
                                        $t(
                                            "message.form.studentData.lastNameEN"
                                        )
                                    }}
                                    <strong>*</strong>
                                </div>
                                <v-text-field
                                    dense
                                    outlined
                                    hide-details="auto"
                                    v-bind:placeholder="
                                        $t(
                                            'message.form.studentData.fillLastNameEN'
                                        )
                                    "
                                    v-model="student_detail.surname_en"
                                    :rules="[
                                        (v) =>
                                            !!v ||
                                            'message.form.studentData.fillLastNameEN',
                                    ]"
                                    required
                                    v-on:keypress="isEngLetter($event)"
                                    @change="onChangeStudentNameEn()"
                                >
                                    <template #message="{ message }">
                                        {{ $t(message) }}
                                    </template></v-text-field
                                >
                            </v-col>
                        </v-row>
                    </v-col>

                    <!--birth-->
                    <v-col cols="12" sm="6" md="6" class="py-0 my-1 pl-3 pr-sm-2 pr-xs-3">
                        <div class="py-1 form-label">
                            {{ $t("message.form.studentData.birthDate") }}
                            <strong>*</strong>
                        </div>
                        <v-menu
                            ref="menu1"
                            v-model="menu1"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="tempBirthday"
                                    append-icon="mdi-calendar"
                                    readonly
                                    v-on="on"
                                    dense
                                    outlined
                                    :rules="birthDateRules"
                                    hide-details="auto"
                                    required
                                    v-bind:placeholder="
                                        $t('message.form.studentData.date')
                                    "
                                    v-bind="attrs"
                                ><template #message="{ message }">
                                {{ $t(message) }}
                            </template></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="birthdayDate"
                                v-on:change="formatDate"
                                color="orange"
                                :locale="locale"
                                width="290"
                                class="mt-4"
                            >
                            </v-date-picker>
                        </v-menu>
                    </v-col>

                    <v-col cols="12" sm="6" md="6" class="py-0 my-1 pl-sm-2 pr-3 pl-xs-3">
                        <div class="py-1 form-label">
                            {{ $t("message.form.studentData.mobileNo") }}
                            <strong>*</strong>
                        </div>
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            placeholder="000 000 0000"
                            v-mask="'### ### ####'"
                            v-model="student_detail.phone_number"
                            :rules="numberRules"
                            required
                        >
                            <template #message="{ message }">
                                {{ $t(message) }}
                            </template></v-text-field
                        >
                    </v-col>

                    <!--nickname step5-->
                    <template v-if="stepActive == 5 || showSectionCondition">
                        <v-col cols="12" sm="6" md="6" class="py-0 my-1 pl-3 pr-sm-2 pr-xs-3">
                            <div class="py-1 form-label">
                                {{ $t("message.form.studentData.nickNameTH") }}
                                <strong>*</strong>
                            </div>
                            <v-text-field
                                dense
                                outlined
                                hide-details="auto"
                                v-bind:placeholder="
                                    $t(
                                        'message.form.studentData.fillNickNameTH'
                                    )
                                "
                                v-model="student_detail.nickname_th"
                                :rules="[
                                    (v) =>
                                        !!v ||
                                        'message.form.studentData.fillNickNameTH',
                                ]"
                                required
                                v-on:keypress="isThaiLetter($event)"
                            >
                                <template #message="{ message }">
                                    {{ $t(message) }}
                                </template></v-text-field
                            >
                        </v-col>

                        <v-col cols="12" sm="6" md="6" class="py-0 my-1 pl-sm-2 pr-3 pl-xs-3">
                            <div class="py-1 form-label">
                                {{ $t("message.form.studentData.nickNameEN") }}
                                <strong>*</strong>
                            </div>
                            <v-text-field
                                dense
                                outlined
                                hide-details="auto"
                                v-bind:placeholder="
                                    $t(
                                        'message.form.studentData.fillNickNameEN'
                                    )
                                "
                                v-model="student_detail.nickname_en"
                                :rules="[
                                    (v) =>
                                        !!v ||
                                        'message.form.studentData.fillNickNameEN',
                                ]"
                                v-on:keypress="isEngLetter($event)"
                                required
                            >
                                <template #message="{ message }">
                                    {{ $t(message) }}
                                </template></v-text-field
                            >
                        </v-col>
                    </template>

                    <!--nation-->
                    <v-col cols="12" sm="6" md="4" class="py-0 my-1 pr-sm-2 pr-xs-3">
                        <div class="py-1 form-label">
                            {{ $t("message.form.studentData.ethnicity") }}
                            <strong>*</strong>
                        </div>
                        <v-select
                            :items="ethnicities"
                            :item-text="locale == 'th' ? 'name_th' : 'name_en'"
                            item-value="value"
                            v-bind:placeholder="
                                $t('message.form.studentData.fillEthnicity')
                            "
                            menu-props="auto"
                            single-line
                            dense
                            outlined
                            hide-details="auto"
                            v-model="student_detail.ethnicity"
                            :rules="[
                                (v) =>
                                    !!v ||
                                    'message.form.studentData.invalidEthnicity',
                            ]"
                            required
                        >
                            <template #message="{ message }">
                                {{ $t(message) }}
                            </template></v-select
                        >
                    </v-col>

                    <v-col cols="12" sm="6" md="4" class="py-0 my-1 pl-sm-2 pr-sm-2 pr-xs-3 pl-xs-3">
                        <div class="py-1 form-label">
                            {{ $t("message.form.studentData.nationality") }}
                            <strong>*</strong>
                        </div>
                        <v-select
                            :items="nationalities"
                            :item-text="locale == 'th' ? 'name_th' : 'name_en'"
                            item-value="value"
                            v-bind:placeholder="
                                $t('message.form.studentData.fillNationality')
                            "
                            menu-props="auto"
                            single-line
                            dense
                            outlined
                            hide-details="auto"
                            v-model="student_detail.nationality"
                            :rules="[
                                (v) =>
                                    !!v ||
                                    'message.form.studentData.invalidNationality',
                            ]"
                            required
                            ><template #message="{ message }">
                                {{ $t(message) }}
                            </template></v-select
                        >
                    </v-col>

                    <v-col cols="12" sm="6" md="4" class="py-0 my-1 pr-md-3 pl-md-2 pr-sm-2 pl-sm-3 pl-xs-3 pr-xs-3">
                        <div class="py-1 form-label">
                            {{ $t("message.form.studentData.religion") }}
                            <strong>*</strong>
                        </div>
                        <v-select
                            :items="religions"
                            :item-text="locale == 'th' ? 'name_th' : 'name_en'"
                            item-value="value"
                            v-bind:placeholder="
                                $t('message.form.studentData.fillReligion')
                            "
                            menu-props="auto"
                            dense
                            outlined
                            hide-details="auto"
                            v-model="student_detail.religion"
                            :rules="[
                                (v) =>
                                    !!v ||
                                    'message.form.studentData.invalidReligion',
                            ]"
                            required
                            ><template #message="{ message }">
                                {{ $t(message) }}
                            </template></v-select
                        >
                    </v-col>
                </v-row>
                <!--hospital step5-->
                <template v-if="stepActive == 5 || showSectionCondition">
                    <v-row align="center">
                        <v-col cols="12" sm="4" md="4">
                            <v-checkbox
                                v-bind:label="
                                    $t('message.form.studentData.siblings')
                                "
                                color="orange"
                                v-model="onlyChild"
                                hide-details="auto"
                                class="mt-n1 form-label"
                                style="width: 300px"
                                @change="onChangeOnlyChild"
                            >
                            </v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                            <v-row>
                                <v-col
                                    cols="12"
                                    sm="7"
                                    md="7"
                                    class="py-0 my-1 pr-0 d-flex align-center"
                                >
                                    <div
                                        class="py-1 form-label"
                                        style="display: absolute"
                                    >
                                        {{
                                            $t("message.form.studentData.child")
                                        }}
                                    </div>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="5"
                                    md="5"
                                    class="py-0 my-1"
                                >
                                    <v-text-field
                                        dense
                                        outlined
                                        hide-details="auto"
                                        v-mask="'#'"
                                        placeholder="0"
                                        v-model="student_detail.relatives_count"
                                        :disabled="onlyChild"
                                        ><template #message="{ message }">
                                            {{ $t(message) }}
                                        </template></v-text-field
                                    >
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                            <v-row>
                                <v-col
                                    cols="12"
                                    sm="7"
                                    md="7"
                                    class="py-0 my-1 pr-0 d-flex align-center"
                                >
                                    <div
                                        class="py-1 form-label"
                                        style="display: absolute; width: 200px"
                                    >
                                        {{
                                            $t(
                                                "message.form.studentData.numberOfChild"
                                            )
                                        }}
                                    </div>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="5"
                                    md="5"
                                    class="py-0 my-1"
                                >
                                    <v-text-field
                                        dense
                                        outlined
                                        hide-details="auto"
                                        v-mask="'#'"
                                        placeholder="0"
                                        v-model="student_detail.relatives_index"
                                        :rules="[
                                            (v) =>
                                                v <=
                                                    student_detail?.relatives_count ||
                                                student_detail?.relatives_count ==
                                                    0 ||
                                                false,
                                        ]"
                                        :disabled="onlyChild"
                                        ><template #message="{ message }">
                                            {{ $t(message) }}
                                        </template></v-text-field
                                    >
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6" md="6" class="py-0">
                            <div class="py-1 form-label">
                                {{ $t("message.form.studentData.birthplace") }}
                                <strong>*</strong>
                            </div>
                            <v-text-field
                                dense
                                outlined
                                hide-details="auto"
                                v-bind:placeholder="
                                    $t(
                                        'message.form.studentData.fillBirthplace'
                                    )
                                "
                                v-model="student_detail.birth_hospital"
                                :rules="[
                                    (v) =>
                                        !!v ||
                                        'message.form.studentData.fillBirthplace',
                                ]"
                                required
                                ><template #message="{ message }">
                                    {{ $t(message) }}
                                </template></v-text-field
                            >
                        </v-col>
                        <v-col cols="12" sm="6" md="6" class="py-0">
                            <div class="py-1 form-label">
                                {{ $t("message.form.studentData.province") }}
                                <strong>*</strong>
                            </div>
                            <v-select
                                dense
                                outlined
                                hide-details="auto"
                                v-bind:placeholder="
                                    $t(
                                        'message.form.studentData.provinceOfBirthplace'
                                    )
                                "
                                v-model="student_detail.hospital_province"
                                :rules="[
                                    (v) =>
                                        !!v ||
                                        'message.form.studentData.invalidProvinceOfBirthplace',
                                ]"
                                required
                                :items="provinces"
                                :item-text="locale == 'th' ? 'name_th' : 'name_en'"
                                item-value="value"
                                ><template #message="{ message }">
                                    {{ $t(message) }}
                                </template></v-select
                            >
                        </v-col>
                    </v-row>
                </template>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script>
import { dateTimeFormat, formatDateTime } from "../../utils/date";
import * as services from "@/services";
import i18n from '@/i18n';
import { GRADE_LEVEL_TYPE_OPTIONS } from "@/constants";

export default {
    name: "StudentForm",
    data: () => ({
        menu1: false,
        student_detail_status: false,
        onlyChild: false,
        birthdayDate: "",
        student_detail: {
            student_year: 0,
            program: "",
            register_plan_id: 0,
            special_skill: "",
            national_id: "",
            gender: "MALE",
            prefix_th: 0,
            prefix_en: 0,
            name_th: "",
            name_en: "",
            surname_th: "",
            surname_en: "",
            birthday: "",
            phone_number: "",
            nickname_th: "",
            nickname_en: "",
            ethnicity: "THA",
            nationality: "THA",
            religion: "BUD",
            relatives_count: 0,
            relatives_index: 0,
            birth_hospital: "",
            hospital_province: 0,
            student_img_base64: {
                data: null,
                type: null
            }
        },
        plans: [],
        student_years: [],
        programs: [],
        prefixEN: [],
        prefixes: [],
        ethnicities: [],
        nationalities: [],
        provinces: [],
        religions: [],

        classroomRules: [
            (v) => !!v || "message.form.classData.errorClassroom",
        ],

        curriculumRules: [
            (v) => !!v || "message.form.classData.errorCurriculum",
        ],

        birthDateRules: [
            (v) => !!v || "message.form.studentData.fillBirthDate",
        ],

        numberRules: [
            (v) => !!v || "message.form.studentData.fillMobileNo",
            (v) => v.length == 12 || "message.form.studentData.leastMobileNo",
        ],

        national_id_rule: [
            (v) => !!v || "message.form.studentData.fillID",
            (v) =>
                (v.length <= 17 && v.length >= 13) ||
                "message.form.studentData.leastID",
        ],
        gradeLevelOptions: GRADE_LEVEL_TYPE_OPTIONS,
    }),
    methods: {
        async inputFile() {
            try {
                const imgInp = document.querySelector("#imgInp");
                const [file] = imgInp.files;
                if (file) {
                    let numberOfBytes = 0;
                    for (const file of imgInp.files) {
                        numberOfBytes += file.size;
                    }

                    // eslint-disable-next-line
                    const fileRegex = /[!@#$%^&*()+\=\[\]{};':"\\|,<>\/?]/;
                    if(fileRegex.test(file.name)){
                        this.student_detail.student_img_base64.data = null;
                        this.student_detail.student_img_base64.type = "error";
                        this.student_detail['student_img_body'] = null;
                        document.querySelector("#camera").style.display = "none";
                        document.querySelector("#text-blah").style.display =
                            "block";
                    }
                    else{
                        if (numberOfBytes > 209715/4 && numberOfBytes < 209715 && (file.type == "image/png" || file.type == "image/jpg" || file.type == "image/jpeg")) {
                            document.querySelector("#text-blah").style.display ="none";
                            const formData = new FormData();
                            formData.append("file", file);
                            try {
                                this.$emit("loadingUpdate", 1);
                                const base64 = await this.convertBase64(file);
                                this.student_detail.student_img_base64.data = base64
                                this.student_detail.student_img_base64.type = file.type
                                this.student_detail['student_img_body'] = {
                                    body: formData,
                                    module: "ENROLL_STUDENT_PROFILE",
                                    fileName: file.name.replaceAll(' ', '_'),
                                    student_id: this.student_id,
                                }

                                // test
                                const test = false
                                if(test){
                                    const res = await services.uploadStudentPicture(this.student_detail.student_img_body.body, {
                                        module: this.student_detail.student_img_body.module,
                                        fileName: this.student_detail.student_img_body.fileName,
                                        student_id: this.student_detail.student_img_body.student_id,
                                    });
                                    console.log(res);

                                }
                            }
                            catch(err){
                                this.student_detail.student_img_base64.data = null;
                                this.student_detail.student_img_base64.type = "error";
                                this.student_detail['student_img_body'] = null;
                                document.querySelector("#camera").style.display = "none";
                                console.log(err);
                            }
                            finally {
                                this.$emit("loadingUpdate", -1);
                            }
                        } else {
                            document.querySelector("#text-blah").style.display ="block";
                            this.student_detail.student_img_base64.data = null;
                            this.student_detail.student_img_base64.type = "error";
                            this.student_detail['student_img_body'] = null;
                            document.querySelector("#camera").style.display = "none";
                        }
                    }
                }
            } catch (err) {
                this.student_detail.student_img_base64.data = null;
                this.student_detail.student_img_base64.type = "error";
                this.student_detail['student_img_body'] = null;
                document.querySelector("#camera").style.display = "none";
                console.log(err);
            }
        },
        convertBase64(file){
            return new Promise((resolve, reject) => {
                const fileReader = new FileReader();
                fileReader.readAsDataURL(file);

                fileReader.onload = () => {
                    resolve(fileReader.result);
                };

                fileReader.onerror = (error) => {
                    reject(error);
                };
            });
        },
        formatDate() {
            let newDate = Date.parse(this.birthdayDate);
            this.student_detail.birthday = dateTimeFormat(newDate);
        },
        filterPrefixesAfterGender(gender){

            if(gender == "MALE"){
                if(this.student_detail.prefix_th != ""){
                    if(["Mrs.", "Ms."].includes(this.student_detail.prefix_th))
                        this.student_detail.prefix_th = ""
                }
                return ["Mr."]
            }
            else if(gender == "FEMALE"){
                if(this.student_detail.prefix_th != ""){
                    if(["Mr."].includes(this.student_detail.prefix_th))
                        this.student_detail.prefix_th = ""
                }
                return ["Mrs.", "Ms."]
            }
            else {
                return ["Mr.", "Mrs.", "Ms."]
            }
        },
        filterPrefixEnAfterGender(gender){

            if(gender == "MALE"){
                if(this.student_detail.prefix_en != ""){
                    if(["Ms.", "Mrs."].includes(this.student_detail.prefix_en))
                        this.student_detail.prefix_en = ""
                }
                return ["Mr."]
            }
            else if(gender == "FEMALE"){
                if(this.student_detail.prefix_en != ""){
                    if(["Mr."].includes(this.student_detail.prefix_en))
                        this.student_detail.prefix_en = ""
                }
                return ["Ms.", "Mrs."]
            }
            else {
                return ["Mr.", "Ms.", "Mrs."]
            }
        },
        processPrefix_EN(obj) {
            if (obj?.prefix_en) {
                this.student_detail.prefix_en =
                    this.prefixEN.find((item) => item.id == obj?.prefix_en)?.id;
            }
            else{
                this.student_detail.prefix_en = ""
            }
        },
        processPrefix_TH(obj) {
            if (obj?.prefix_th) {
                this.student_detail.prefix_th = this.prefixes.find((item) => item.id == obj?.prefix_th)?.id
            }
            else{
                this.student_detail.prefix_th = ""
            }
        },
        validate() {
            return this.$refs.form.value && this.checkPicture;
        },
        isEngLetter(e) {
            let char = String.fromCharCode(e.keyCode); // Get the character
            if (/^[A-Za-z'-]+$/.test(char)) return true;
            // Match with regex
            else e.preventDefault(); // If not match, don't add to input text
        },
        isNationalLetter(e) {
            let char = String.fromCharCode(e.keyCode); // Get the character
            if (/^[A-Za-z0-9]/.test(char)) return true;
            // Match with regex
            else e.preventDefault(); // If not match, don't add to input text
        },
        isThaiLetter(e) {
            let char = String.fromCharCode(e.keyCode); // Get the character
            if (/^[\u0E00-\u0E7Fa-zA-Z'-]+$/.test(char)) return true;
            // Match with regex
            else e.preventDefault(); // If not match, don't add to input text
        },
        onChangeOnlyChild() {
            if (this.onlyChild) {
                this.student_detail.relatives_count = 0;
                this.student_detail.relatives_index = 0;
            }
        },
        async fetchInitData() {
            this.student_detail.student_year = this.registrationFormDetail?.grade_level;

            try {
                this.$emit("loadingUpdate", 1);
                let data = await getPersonalDetail();

                data.prefix.map((item) => {
                    if (item.text_th == 'เด็กชาย') item.text_th = "ด.ช."
                    if (item.text_th == 'เด็กหญิง') item.text_th = "ด.ญ.";

                    this.prefixes.push(item);
                    this.prefixEN.push(item);
                });
                this.student_detail.prefix_th = this.prefixes.find((item) => item.text_th == 'ด.ช.')?.id;
                this.student_detail.prefix_en = this.prefixEN.find((item) => item.text_th == 'ด.ช.')?.id;

                data.ethnicity.map((item) => {
                    this.ethnicities.push(item);
                });
                this.student_detail.ethnicity = this.ethnicities.find((item) => item.value == 'THA')?.value;

                data.nationality.map((item) => {
                    this.nationalities.push(item);
                });
                this.student_detail.nationality = this.nationalities.find((item) => item.value == 'THA')?.value;

                data.religion.map((item) => {
                    this.religions.push(item);
                });
                this.student_detail.religion =this.religions.find((item) => item.value == 'BUD')?.value;


                data = await getProvince();

                data.province.map((item) => {
                    this.provinces.push(item);
                });
                this.registrationFormDetail.register_plans.map((plan) => {
                    this.plans.push(plan);
                    this.student_years.push(plan.student_year);
                });
                this.programs.sort((a, b) => a.value - b.value);
                this.student_years.sort((a, b) => a.value - b.value);

                if (this.student_detail?.student_year) this.onChangeStudentYear();

                if (this.stepActive == 5 || this.from == "candidates") {
                    this.fetchInitStudentQuery();
                }
            } finally {
                this.$emit("loadingUpdate", -1);
            }
        },
        onChangeStudentYear() {
            try {
                this.$emit("loadingUpdate", 1);
                this.programs = [];
                this.plans.map((plan) => {
                    if (
                        plan?.student_year?.value ==
                        this.student_detail?.student_year
                    ) {
                        this.programs.push(plan.program);
                    }
                });
                this.$emit(
                    "targetStudentYear",
                    this.student_detail?.student_year
                );
            } finally {
                this.$emit("loadingUpdate", -1);
            }
        },
        onSelectProgram() {
            this.plans.map((plan) => {
                if (
                    plan?.student_year?.value ==
                        this.student_detail?.student_year &&
                    plan?.program?.value == this.student_detail?.program
                ) {
                    this.student_detail.register_plan_id = plan.id;
                    return;
                }
            });
        },
        onChangeData() {
            this.$emit("formValidate", this.validate());
        },
        async fetchInitStudentQuery() {
            try {
                this.$emit("loadingUpdate", 1);
                const body = {
                    query: {
                        selects: {
                            id: true,
                            student_detail: {
                                prefix_id: true,
                                name_th: true,
                                surname_th: true,
                                name_en: true,
                                surname_en: true,
                                special_skill: true,
                                national_id: true,
                                gender: true,
                                birthday: true,
                                phone_number: true,
                                student_img: true,
                            },
                            register_plan: true,
                        },
                        relations: {
                            student_detail: {
                                prefix_id: true,
                                ethnicity: true,
                                nationality: true,
                                religion: true,
                            },
                            register_plan: {
                                program: true,
                                student_year: true,
                            },
                        },
                    },
                };
                if (this.from == "candidates") {
                    body["id"] = this.student_id;
                    if (this.stepActive == 5) {
                        body.query.selects.student_detail = {
                            ...body.query.selects.student_detail,
                            relatives_count: true,
                            relatives_index: true,
                            has_relatives: true,
                            birth_hospital: true,
                            nickname_th: true,
                            nickname_en: true,
                        };
                        body.query.relations.student_detail = {
                            ...body.query.relations.student_detail,
                            hospital_province: true,
                        };
                    }
                } else if (this.stepActive == 5) {
                    body["token"] = localStorage.getItem("token");
                }
                const {
                    data: { data },
                } = await services.getStudentWithQuery(body);
                const studentData = data.student;
                let student_img = null;
                if (studentData?.student_detail?.student_img) {
                    let imageData = await services.getImageBase64FromUrl(
                        studentData?.student_detail?.student_img
                    );
                    student_img = imageData.data.data.data;
                    data.student.student_detail["student_img_base64"] =
                        student_img;
                }
                this.autoFillDataFromDb(data.student);
            } finally {
                this.$emit("loadingUpdate", -1);
            }
        },
        autoFillDataFromDb(data) {
            try {
                this.$emit("loadingUpdate", 1);
                Object.keys(data.student_detail).forEach((key) => {
                    if (
                        key == "ethnicity" ||
                        key == "nationality" ||
                        key == "religion"
                    ) {
                        this.student_detail[key] =
                            data.student_detail[key].value;
                    } else if (key == "prefix_id") {
                        this.student_detail["prefix_th"] =
                            data.student_detail[key].id;
                        this.student_detail["prefix_en"] =
                            data.student_detail[key].text_en;
                    } else if (key == "birthday") {
                        this.birthdayDate = data.student_detail[key];
                        this.formatDate();
                    } else if (key == "has_relatives") {
                        this.onlyChild = !data.student_detail[key];
                    } else if (key == "hospital_province") {
                        this.student_detail[key] =
                            data.student_detail[key]?.value;
                    } else {
                        this.student_detail[key] = data.student_detail[key];
                    }
                });
                this.student_detail.register_plan_id = data.register_plan.id;
                this.student_detail.student_year = data.register_plan.student_year.value;
                this.onChangeStudentYear();
                this.student_detail.program = data.register_plan.program.value;
            } finally {
                this.$emit("loadingUpdate", -1);
            }
        },
        onChangeStudentNameTh() {
            if (!this.student_detail?.name_th || !this.student_detail?.surname_th) return;

            this.$emit(
                "changeStudentNameTh",
                `${this.student_detail?.name_th}_${this.student_detail?.surname_th}`
            );
        },
        onChangeStudentNameEn() {
            if (!this.student_detail?.name_en || !this.student_detail?.surname_en) return;

            this.$emit(
                "changeStudentNameEn",
                `${this.student_detail?.name_en}_${this.student_detail?.surname_en}`
            );
        },
    },
    props: {
        checkValidate: Boolean,
        callAutoFill: Boolean,
        stepActive: Number,
        registrationFormDetail: Object,
        student_id: Number,
        widthProp: {
            default: "690",
            type: String,
        },
        registrationState: {
            default: "all",
            type: String,
        },
        from: {
            default: "all",
            type: String,
        },
    },
    emits: ["formValidate", "targetStudentYear"],
    watch: {
        checkValidate: function () {
            this.validate();
        },
        callAutoFill: function () {
            this.autoFill();
        },
    },
    mounted() {
        this.fetchInitData();
    },
    computed: {
        locale(){
            return i18n.locale
        },
        responsiveWithFrom() {
            if (this.from == "candidates") return 3;
            return 5;
        },
        showSectionCondition() {
            try {
                let allow_state = [
                    "SUCCESSFUL_CONFIRMATION_DETAIL",
                    "SUCCESSFUL_ENROLLMENT",
                ];
                if (this.from == "all") return false;
                if (
                    this.from == "candidates" &&
                    allow_state.includes(this.registrationState)
                )
                    return true;
                return false;
            } catch (error) {
                return false;
            }
        },
        disabledRules() {
            if (this.stepActive == 5 && this.$route?.query?.action == "view")
                return true;
            return false;
        },
        checkPicture(){
            // show default picture when false
            return 'student_img_base64' in this.student_detail &&
                    this.student_detail?.['student_img_base64']?.data != undefined &&
                    this.student_detail?.['student_img_base64']?.data != null
        },
        tempBirthday() {
            if (!this.birthdayDate) return "";
            return formatDateTime(
                this.birthdayDate,
                this.locale
            );
        },
    },
    updated() {
        this.onChangeData();
    },
};

const getPersonalDetail = async () => {
    const {
        data: { data },
    } = await services.getPersonalDetail();
    return data;
};

const getProvince = async () => {
    const {
        data: { data },
    } = await services.getProvince();
    return data;
};
</script>

<style scoped>
.form-label{
    font-size: 18px;
}
</style>
